import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';
import queryClient from '@/lib/queryClient';

export const useRankings = () => {
  return useQuery({
    queryKey: ['rankings'],
    queryFn: () => _a.rankings(),
  });
};
